<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)" />
			<div class="big_tit">
				交易明细
			</div>
		</div>
		<div class="wrap_box">
			<div class="form-wrapper">
				<form class="card-form">
					<div class="form-title">此笔转账汇款指令的详细信息如下：</div>
					<div class="form-group">
						<label>付款开户行</label>
						<input type="text" value="国家开发银行" disabled>
					</div>

					<div class="form-group">
						<label>付款账号</label>
						<input type="number" value="6222022200000646469" disabled>
					</div>

					<div class="form-group">
						<label>交易渠道</label>
						<input type="text" value="网上银行" disabled>
					</div>
					<div class="form-group">
						<label>汇款时间</label>
						<input type="text" value="实时汇款" disabled>
					</div>
					<div class="form-group mark">
						<label>收款人：</label>
						<input type="text" v-model="data.name" disabled>
					</div>
					<div class="form-group">
						<label>收款账号：</label>
						<input v-model="bankdata.account" disabled>
					</div>
					<div class="form-group">
						<label>收款开户行：</label>
						<input v-model="bankdata.area" disabled>
					</div>
					<div class="form-group">
						<label>交易状态：</label>
						<input type="text" value="汇款成功" disabled>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "onlineBankDetails",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				bankdata: {}
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			this.banksum();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			banksum() {
				Fetch('/user/my_bank').then(r => {
					this.bankdata = r.data.bank[0];
					console.log(this.bankdata);
				})
			},
		}
	};
</script>

<style lang="less" scoped>
	.big_tit {
		color: #fff;
	}

	.wrap_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 0px;
		background-image: url(../images/user/onlineBankDetails.jpg);
		background-size: 100%;
		background-position: center;
		background-repeat: no-repeat;
		height: calc(100vh - 44px);
	}

	.auth {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	
	.form-wrapper {
		position: absolute;
		top: 53%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 75%;
		height: 410px;
		max-width: 375px;
		// background: #fff;
		padding: 0 10px 20px;
		// border-radius: 8px;
		// box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}
	
	.form-title {
		width: 100%;
		// margin: 0 auto 10px;
		// background: #d7000f;
		// color: #fff;
		// border-radius: 0 0 12px 12px;
		padding: 5px 0;
		font-size: 12px;
		// text-align: center;
		margin-bottom: 10px;
		font-weight: bold;
	}
	
	.form-group {
		margin-bottom: 12px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		// border-bottom: 1px solid #ddd;
	}
	
	.form-group label {
		color: #8d8e96;
	}
	
	.mark {
		margin-top: 25%;
	}
</style>